import * as Ariakit from '@ariakit/react'

export const useComboBoxState = Ariakit.useComboboxStore
